const HomeIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected ? 'var(--forbrand-primary)' : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
    <svg width="24" height="24" viewBox="0 0 24 24" fill={fillColor} xmlns="http://www.w3.org/2000/svg">
<path d="M15.75 19.4998V11.9998H8.25V19.4998H4.5V9.15526L12 3.20701L19.5 9.15526V17.9998H21V10.3449L22.4092 11.4626L23.3408 10.287L12 1.29248L0.65918 10.287L1.59083 11.4626L3 10.3449V20.9998H19.9496L21 19.4998H15.75ZM9.75 13.4998H14.25V19.4998H9.75V13.4998Z" fill="#111113"/>
</svg>

    </div>
  )
}

export default HomeIcon
